import { Stack } from '@mui/material'
import { useCallback, useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

import preloadAccountPortalRoutes from '~/app/utils/lazy/accountPortalLazyLoadingUtils'
import LoadingWithBackdrop from '~/components/loadingWithBackdrop'
import OidcSignIn from '~/features/auth/components/signIn/oidcSignIn'
import PartnerThemeWrapper from '~/features/partners/components/partnerThemeWrapper'
import { isLibbyDomain, shouldDisplayVgLogin } from '~/features/partners/utils'
import usePrivateRoutesRedirect from '~/hooks/usePrivateRoutesRedirect'
import { EClientPath } from '~/models/api'
import rem from '~/utils/ui'

function PartnerAuth() {
  const navigate = useNavigate()

  const isAuthCheckComplete = usePrivateRoutesRedirect({
    requiredUserGroups: null,
    isPartnerAuthPage: !isLibbyDomain(),
  })

  useEffect(() => {
    preloadAccountPortalRoutes()
  }, [])

  const render = useCallback(() => {
    // Always show the sign up form when coming from /demo
    if (shouldDisplayVgLogin()) {
      return <OidcSignIn />
    }

    navigate(EClientPath.login, {
      state: { isPartnerThemed: true },
    })
    return null
  }, [navigate])

  if (!isAuthCheckComplete) {
    return <LoadingWithBackdrop show />
  }

  return (
    <PartnerThemeWrapper>
      <Stack
        sx={{
          justifyContent: 'center',
          alignItems: 'center',
          height: '100vh',
          '& form': {
            width: { xxxs: rem(260), xs: rem(280) },
          },
        }}
      >
        {render()}
      </Stack>
    </PartnerThemeWrapper>
  )
}

export default PartnerAuth
